import React,{useEffect,useRef} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import VideoStream from './pages/VideoStream';
import Preferences from './pages/Preferences';
import Shopping from './pages/Shopping';
import PastOrders from './pages/PastOrders';
import Audio from './pages/Audio';
import Chat from './pages/Chat';
import { Utils } from './Utils';
import { AppConstants } from './AppConstants';

import OneSignal from 'react-onesignal';

function App() {
  const isInitialized = useRef(false);
  useEffect(() => {
    const initOneSignal = async () => {
      // 1. SILENTLY STOP if we already started (Fixes the 1st error)
      if (isInitialized.current) return;
      
      try {
        if(Utils.isOnIOSAndNotRunningAsHomeApp()) {isInitialized.current = true; return ;}
        await OneSignal.init({
          appId: AppConstants.ONESIGNAL_APP_ID,
          allowLocalhostAsSecure: true, 
          displayInForeground: true,
          notificationClickHandlerMatch: 'origin',
          notificationClickHandlerAction: 'focus',
          notifyButton: { enable: true }
        });
        OneSignal.Notifications.addEventListener("foregroundWillDisplay", (event) => {
          console.log("Notification received in foreground!");
          event.notification.display(); // This forces the popup to show 
        });
        isInitialized.current = true;
        console.log("✅ OneSignal Initialized");
        // Triggered when a notification is received while the app is open
        OneSignal.Notifications.addEventListener("foregroundWillDisplay", (event) => {
          console.log("Notification arriving in foreground:", event.notification);
          // You can choose to prevent the default display and show a custom UI toast instead
          // event.preventDefault(); 
        });
        // Triggered when the user clicks the notification
        OneSignal.Notifications.addEventListener("click", (event) => {
          navigate('/chat');
        });
      } catch (err) {
        // 2. CHECK if it's just the "Already Initialized" error and ignore it
        if (err.message && err.message.includes("already initialized")) {
          isInitialized.current = true;
          return;
        }
        console.error("❌ OneSignal Error:", err);
      }
    };

  //TODO: Future initOneSignal();
}, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/video-stream" element={<VideoStream />} />
        <Route path="/preferences" element={<Preferences />} />
        <Route path="/shopping" element={<Shopping />} />
        <Route path="/past-orders" element={<PastOrders />} />
        <Route path="/audio" element={<Audio />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
